<template>
  <div>
    <header class="header">
      <div class="container">
        <div class="header__wrapper">
          <a href="/" class="header__link">
            <img src="../assets/img/logotype.png" alt="Logotype" class="header__logotype"/>
          </a>
          <div class="header__singly">
            <div class="mr-5">
              <v-select :options="getLangOptions" v-model="lang" :flags="true" :search="true"/>
            </div>
            <div class="timer">
              <div class="timer__text">You have:</div>
              <div class="position-relative">
                <radial-progress-bar :diameter="65"
                                     startColor="#39833c"
                                     stopColor="#39833c"
                                     innerStrokeColor="#e0e0e0"
                                     :strokeWidth="5"
                                     :innerStrokeWidth="5"
                                     :isClockwise="false"
                                     :completed-steps="getTestTimer"
                                     :total-steps="getTestCountdown"/>
                <span class="timer-mins"><b>{{ getTestMins }}</b> min</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="test">
      <div class="container">
        <div class="test__caption">Competency Test</div>
        <div class="test__wrapper" v-if="getTestStatus === 'ready'">
          <div class="test__btn">
            <button class="btn" @click="onStart()">Start test</button>
          </div>
        </div>
        <div class="test__wrapper" v-if="showTest">
          <div class="test__box" v-for="question of getTest" :key="question.id">
            <div class="test__matter">{{ question.text[lang] || question.text['en'] }}</div>
            <div class="test__variant" v-for="answer of question.answers">

              <template v-if="!question.multiple">
                <input :id="'answer' + answer.id"
                       :name="'qwestion'+question.id"
                       type="radio"
                       class="test__radio"
                       v-model="form[question.id]"
                       :value="answer.id"/>
                <label :for="'answer' + answer.id" class="test__label">
                  {{ answer.text[lang] || answer.text['en'] }}
                </label>
              </template>

              <div class="questions__checkbox" v-if="question.multiple">
                <label class="checkbox">
                  <input type="checkbox" v-model="form[question.id]" :value="answer.id"/>
                  <span class="checkbox__part">
                      <span class="checkbox__text">
                        {{ answer.text[lang] || answer.text['en'] }}
                      </span>
                    </span>
                </label>
              </div>

            </div>
          </div>
          <div class="test__btn">
            <button class="btn" @click="onSubmit()">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import RadialProgressBar from 'vue-radial-progress'
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: "Test",
    components: {RadialProgressBar},
    props: ['hash'],
    data() {
      return {
        lang: 'en',
        showTest: false,
        form: {}
      }
    },
    mounted() {
      this.lang = navigator.language.slice(0, 2)
      this.queryTest(this.hash)
      console.log('Set locale "' + this.lang + '"')
    },
    computed: {
      ...mapGetters([
        'getTest',
        'getTestCountdown',
        'getTestTimer',
        'getTestStatus',
        'getTestMins',
        'getLangOptions',
      ])
    },
    watch: {
      getTest(val) {
        if (val !== undefined)
          this.showTest = !!val.length

        for (let item of val) {
          if (item.multiple)
            this.form[item.id] = []
          else
            this.form[item.id] = null
        }
      }
    },
    methods: {
      ...mapActions([
        'showModal',
        'queryTest',
        'queryCheckAnswers',
        'queryStartTest',
      ]),
      onSubmit() {
        this.queryCheckAnswers({hash: this.hash, form: this.form})
      },
      onStart() {
        this.queryStartTest([this.hash, {_method: 'PUT'}])
      }
    },

  }
</script>

<style lang="scss">
  .timer-mins {
    position: absolute;
    top: 0;
    left: 0;
    padding: 18px 5px;
    text-align: center;
    line-height: 15px;
    width: 65px;
    font-size: 13px;
    b {
      display: block;
    }
  }
</style>